<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="ClipboardIcon" size="19"/>
      <h4 class="mb-0 ml-50">
        {{ $t('PLANS_DETAILS_TITLE') }}
      </h4>
    </div>

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('name')">
      <b-col md="6">
        <b-form-group :label="$t('PLANS_NAME_LABEL')">
          <b-form-input 
            :disabled="$store.getters['containerAreaPlan.form/isReadOnly']"
            @input="(value)=> $store.commit('containerAreaPlan.form/updateName', {value})"
            :value="$store.getters['containerAreaPlan.form/name']"
            :placeholder="$t('PLANS_NAME_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('name' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['name'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('device_id')">
      <b-col md="6">
        <b-form-group :label="$t('PLANS_DEVICE_LABEL')">
          <v-select 
            :disabled="$store.getters['containerAreaPlan.form/isReadOnly']"
            :placeholder="$t('PLANS_DEVICE_PLACEHOLDER')" 
            @input="(value)=> {
              $store.commit('containerAreaPlan.form/updateDeviceId', {value})
              $store.dispatch('containerAreaPlan.form/fetchCampOptions')
            }"
            :value="$store.getters['containerAreaPlan.form/device_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="device => device.name" 
            :options="$store.getters['containerAreaPlan.form/deviceOptions']" 
            :reduce="device => device.device_id" 
          />
          <small v-if="('device_id' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['device_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('camp_id')">
      <b-col md="6">
        <b-form-group :label="$t('PLANS_CAMP_LABEL')">
          <v-select 
            :disabled="$store.getters['containerAreaPlan.form/isReadOnly']"
            :placeholder="$t('PLANS_CAMP_PLACEHOLDER')" 
            @input="(value)=> $store.commit('containerAreaPlan.form/updateCampId', {value})"
            :value="$store.getters['containerAreaPlan.form/camp_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="camp => camp.name" 
            :options="$store.getters['containerAreaPlan.form/campOptions']" 
            :reduce="camp => camp.geofence_id" 
          />
          <small v-if="('camp_id' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['camp_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('camp_leave')">
      <b-col md="6">
        <b-form-group :label="$t('PLANS_CAMP_LEAVE_LABEL')">
          <flat-pickr 
              :disabled="$store.getters['containerAreaPlan.form/isReadOnly']"
              :placeholder="$t('PLANS_CAMP_LEAVE_PLACEHOLDER')" 
              @input="(value)=> $store.commit('containerAreaPlan.form/updateCampLeave', {value})"
              :value="$store.getters['containerAreaPlan.form/camp_leave']"
              :config="$store.getters['containerAreaPlan.form/campTimeConfig']"
              class="form-control" 
            />
          <small v-if="('camp_leave' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['camp_leave'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

      <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('camp_back')">
      <b-col md="6">
        <b-form-group :label="$t('PLANS_CAMP_BACK_LABEL')">
          <flat-pickr 
              :disabled="$store.getters['containerAreaPlan.form/isReadOnly']"
              :placeholder="$t('PLANS_CAMP_BACK_PLACEHOLDER')" 
              @input="(value)=> $store.commit('containerAreaPlan.form/updateCampBack', {value})"
              :value="$store.getters['containerAreaPlan.form/camp_back']"
              :config="$store.getters['containerAreaPlan.form/campTimeConfig']"
              class="form-control" 
            />
          <small v-if="('camp_back' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['camp_back'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('work_days')">
      <b-col md="12">
        <b-form-group :label="$t('PLANS_WORK_DAYS_LABEL')">
          <b-form-checkbox-group 
              v-model='workDays'
              :options="$store.getters['containerAreaPlan.form/workDaysOptions']"
              name="flavour-1a"
              inline
            />
          <small v-if="('work_days' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['work_days'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

   

    <b-row class="mt-2" v-if="$store.getters['containerAreaPlan.form/fields'].includes('areas')">
      <b-col md="12">
        <b-form-group :label="$t('PLANS_AREAS_LABEL')">
          <b-form-file 
              class="w-50 mb-2 mt-2"
              accept="txt/kml" 
              @input="(file)=> $store.dispatch('containerAreaPlan.form/importAreasFromKML', {file})"
              :browse-text="$t('IMPORT_KML_LABEL')"
          />
          <area-form-repeater store='containerAreaPlan.form' />
          <small v-if="('areas' in $store.getters['containerAreaPlan.form/errors'])" class="text-danger">
            {{ $t($store.getters['containerAreaPlan.form/errors']['areas'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>



  </div>
</template>

<script>

import { computed } from '@vue/composition-api'

import store from '@/store'

import { 
  BButton, 
  BCol, 
  BForm, 
  BFormGroup,
  BFormCheckbox,
  BFormInput, 
  BInputGroup, 
  BFormCheckboxGroup,
  BRow,
  BFormFile
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'

import AreaFormRepeater from './AreaFormRepeater.vue'

export default {
  components: { 
    BRow, 
    BCol, 
    BFormGroup,
    BFormCheckbox,
    BFormInput, 
    BInputGroup, 
    BForm, 
    BButton, 
    vSelect,
    flatPickr,
    BFormFile,
    AreaFormRepeater,
    BFormCheckboxGroup
  },
  setup( props, { root }) {

    const workDays = computed({
      set(value){
        store.commit('containerAreaPlan.form/updateWorkDays', {value})
      },
      get(){
        return store.getters['containerAreaPlan.form/work_days']
      }
    })

    store.commit('containerAreaPlan.form/updateRoot', root)
    store.dispatch('containerAreaPlan.form/fetchOptions')

    return { workDays }
  }
}
</script>

<style scoped>

</style>
